// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TheStartForm_wrapper_2Sy3F","title":"TheStartForm_title_3Y104","input":"TheStartForm_input_3nC50","button":"TheStartForm_button_144DC"};